import {camelCase, capitalize, startCase, upperFirst} from "lodash-es";

export const pascalCase = (str) => upperFirst(camelCase(str));
export const sentenceCase = (str) => startCase(camelCase(str));
/**
 * @param {string} str
 * @returns {string} Sentence structure with only first word capitalized.
 */
export const sentenceRestLowerCase = (str) => capitalize(sentenceCase(str));

/**
 * @param {string} value
 * @returns {string} string with underscores replaced with spaces
 */
export const replaceUnderscoreWithSpace = (value) =>
  value ? value.replaceAll("_", " ") : "";
